/* eslint-disable no-nested-ternary */
/* eslint-disable react/prop-types */
/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-present Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */

import useStyles from 'isomorphic-style-loader/useStyles';
import React, { useState, useEffect } from 'react';
import {
  Col,
  Button,
  Modal,
  Form,
  Input,
  notification,
  Row,
  Dropdown,
  Menu,
} from 'antd';
import { UserOutlined, LockOutlined, MailOutlined } from '@ant-design/icons';
import { put, post } from 'axios';
import { endpoints } from '@source/config';
import logoUrl from '@global/assets/logoYoloya.png';
import s from './index.css';
import ModalRegister from '../ModalRegistrasi';
import loginLabel from './language';
import ModalChangePassword from '../ModalChangePassword';

export default function ModalLogin(props) {
  useStyles(s);
  const [loading, setLoading] = useState(false);
  const [isToken, setIsToken] = useState(false);
  const [visible, setVisible] = useState(props.visible);
  const [visibleDropdown, setVisibleDropdown] = useState(false);
  const [forget, setForget] = useState(false);
  const [label, setLabel] = useState(loginLabel(props.language));
  const [showModalPass, setShowModalPass] = useState(false);
  const isMobile = props.isMobile

  const updateToken = () => {
    if (props.tokenUser) {
      setIsToken(true);
    } else {
      setIsToken(false);
    }
  };

  useEffect(() => {
    setVisible(props.visible);
  }, [props.visible]);

  useEffect(() => {
    window.addEventListener('scroll', () => {
      setVisibleDropdown(false);
    });
  }, []);

  useEffect(() => {
    updateToken();
    document.addEventListener(
      'sessionChanged',
      () => {
        updateToken();
      },
      false,
    );
  }, []);

  const changeForget = condition => {
    setForget(condition);
  };

  const handleLogin = value => {
    setLoading(true);
    if (!forget) {
      post(`${endpoints.api}auth/login`, {
        username: value.userName,
        password: value.Password,
      })
        .then(res => {
          const response = res.data;
          if (response.role === 'Umum' || response.role === 'Loyola') {
            const expired = response.auth.expiresIn; // response di BE sudah detik
            console.log(`max-age=${expired}`);
            document.cookie = `_at=${response.auth.authorization}; max-age=${expired}; path=/`; // token
            document.cookie = `UID=${response.data.userId}; max-age=${expired}; path=/`; // uId
            document.cookie = `userDataId=${response.data.userId}; max-age=${expired}; path=/`; // uId
            document.cookie = `roleUser=${response.data.authorities[0].authority}; max-age=${expired}; path=/`; // userRole
            const dataDetail = {
              ...response.data.usersDetail,
              username: response.data.username,
            };
            document.cookie = `userData=${JSON.stringify(
              dataDetail,
            )}; max-age=${expired}; path=/`;
            setLoading(false);
            props.handleLogin(false);
            if (response.responseType !== 'Success') {
              setTimeout(() => location.reload(), 500);
            }
          } else {
            setLoading(false);
            notification.error({
              placement: 'bottomRight',
              message: 'Error',
              description: label.notifikasi.error.descriptionLogin,
            });
          }
        })
        .catch(error => {
          setLoading(false);
          notification.error({
            placement: 'bottomRight',
            message: 'Error',
            description: error.data
              ? error.data.message
              : label.notifikasi.error.descriptionLogin,
          });
        });
    } else {
      const isEng = props.language == 'eng';
      put(
        `${endpoints.api}noAuth/be/api/users/forgotPassword?isEng=${isEng}&isAdmin=false`,
        {
          email: value.email,
        },
      )
        .then(res => {
          const response = res.data;
          if (response.responseType == 'Success') {
            setLoading(false);
            notification.success({
              placement: 'bottomRight',
              message: response.responseType,
              description: response.message,
            });
            handleClose();
          } else {
            setLoading(false);
            notification.warning({
              placement: 'bottomRight',
              message: response.responseType,
              description: response.message,
            });
          }
        })
        .catch(error => {
          setLoading(false);
          notification.error({
            placement: 'bottomRight',
            message: 'Error',
            description: error.data
              ? error.data.Message
              : label.notifikasi.error.description,
          });
        });
    }
  };

  const handleLogout = () => {
    const isEng = props.language;
    document.cookie.split(';').forEach(cookies => {
      document.cookie = cookies
        .replace(/^ +/, '')
        .replace(/=.*/, `=;expires=${new Date().toUTCString()};path=/`);
    });

    document.cookie = `language=${isEng}; max-age=${30 * 24 * 60 * 60}; path=/`;
    setTimeout(() => location.reload(), 1000);
  };

  const handleClose = () => {
    setForget(false);
    props.handleCancelLogin();
  };

  const toggleChangePass = () => {
    setShowModalPass(!showModalPass);
  };

  const finishChangePass = () => {
    toggleChangePass();
    handleLogout();
  };

  return (
    <>
      <Col span="24" style={{ paddingBottom: 0 }}>
        {!isToken && !props.noButton ? (
          <Button
            block
            hidden={props.hiddenButton}
            className={s.buttonHeader}
            onClick={() => (isToken ? handleLogout() : props.handleLogin(true))}
            // loading={loading}
          >
            {isToken ? label.logout : label.login}
          </Button>
        ) : !props.noButton ? (
          <Button
            type="link"
            hidden={props.hiddenButton}
            className={s.hiddenButton}
          >
            <Dropdown
              overlay={
                <Menu className={s.navMenu} style={{ marginTop: '10px' }}>
                  <Menu.Item key="1">
                    <div className={s.link} onClick={toggleChangePass}>
                      {label.changePass}
                    </div>
                  </Menu.Item>
                  <Menu.Item key="2">
                    <div className={s.link} onClick={() => handleLogout()}>
                      {label.logout}
                    </div>
                  </Menu.Item>
                </Menu>
              }
              visible={visibleDropdown}
              onVisibleChange={_ => {
                setVisibleDropdown(!visibleDropdown);
              }}
              trigger={['click']}
              placement="bottomLeft"
            >
              <span className={s.titleHeader}>
                {props.userData && props.userData.username
                  ? `${props.userData.username.substring(0, 15)}${
                      props.userData.username.length > 15 ? '...' : ''
                    }`
                  : 'User'}
              </span>
            </Dropdown>
          </Button>
        ) : (
          ''
        )}
      </Col>
      <Modal
        title="Login"
        visible={visible}
        width={760}
        centered
        className={s.modalStyle}
        onCancel={() => handleClose()}
      >
        <Row>
          <Col span={isMobile ? 24 : 10} style={{ background: '#11174E' }}>
            <div className={s.containLeft}>
              <Row gutter={[0, 8]}>
                <Col span={24}>
                  <img width={100} height={100} src={logoUrl} alt="logoLyl" />
                </Col>
                <Col span={24} style={{ marginBottom: '130px' }}>
                  <span className={s.textLeft}>
                    YAYASAN LOYOLA
                    <br />
                    SMA KOLESE LOYOLA
                  </span>
                </Col>
                <Col span={24}>
                  <span className={s.textLeftAkun}>{label.punyaAkun}</span>
                </Col>
                <Col span={24}>
                  <ModalRegister isMobile={props.isMobile} language={props.language} disabled={loading} />
                </Col>
              </Row>
            </div>
          </Col>
          <Col span={isMobile ? 24 : 14} style={{ background: '#DFE0E1' }}>
            <div className={s.cotainerContent}>
              <Form
                name="normal_login"
                className="login-form"
                initialValues={{ remember: true }}
                onFinish={handleLogin}
              >
                <Form.Item style={{ textAlign: 'left', marginBottom: '50px' }}>
                  <span className={s.textLogin}>
                    {forget
                      ? props.language === 'eng'
                        ? 'Forgot Password?'
                        : 'Lupa Password?'
                      : label.login}
                  </span>
                </Form.Item>
                {forget ? (
                  <div>
                    <Form.Item
                      style={{ marginBottom: '40px' }}
                      name="email"
                      rules={[
                        {
                          required: true,
                          message: label.emailRequired,
                        },
                      ]}
                    >
                      <Input
                        className={s.inputStyleLogin}
                        prefix={
                          <MailOutlined className="site-form-item-icon" />
                        }
                        placeholder={label.email}
                        type="email"
                      />
                    </Form.Item>
                    <Form.Item style={{ marginBottom: '12px' }}>
                      <Button
                        block
                        style={{ height: '46px' }}
                        className={s.buttonLogin}
                        htmlType="submit"
                        loading={loading}
                      >
                        {label.submit}
                      </Button>
                    </Form.Item>
                    <Form.Item style={{ margin: '0px' }}>
                      <Button
                        type="text"
                        style={{ height: '46px' }}
                        className={s.buttonBack}
                        onClick={() => changeForget(false)}
                        disabled={loading}
                      >
                        {label.back}
                      </Button>
                    </Form.Item>
                  </div>
                ) : (
                  <div>
                    <Form.Item
                      name="userName"
                      rules={[
                        {
                          required: true,
                          message: label.usernameRequired,
                        },
                      ]}
                    >
                      <Input
                        className={s.inputStyleLogin}
                        prefix={
                          <UserOutlined className="site-form-item-icon" />
                        }
                        placeholder={label.username}
                      />
                    </Form.Item>
                    <Form.Item
                      style={{ margin: '0px' }}
                      name="Password"
                      rules={[
                        {
                          required: true,
                          message: label.passwordRequired,
                        },
                      ]}
                    >
                      <Input.Password
                        className={s.inputStyleLogin}
                        prefix={
                          <LockOutlined className="site-form-item-icon" />
                        }
                        type="password"
                        placeholder={label.password}
                      />
                    </Form.Item>
                    <div className="right">
                      <span
                        className={s.lupaStyle}
                        onClick={() => changeForget(true)}
                      >
                        {label.lupaPassword}
                      </span>
                    </div>
                    <Button
                      block
                      style={{ height: '46px' }}
                      className={s.buttonLogin}
                      htmlType="submit"
                      loading={loading}
                    >
                      {label.login}
                    </Button>
                  </div>
                )}
              </Form>
            </div>
          </Col>
        </Row>
      </Modal>
      {showModalPass && (
        <ModalChangePassword
          onCancel={toggleChangePass}
          onFinish={finishChangePass}
          language={props.language}
          userData={props.userData}
          token={props.tokenUser}
        />
      )}
    </>
  );
}
